import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { captureAttribution } from './features/growth/attribution';
import { initialLanguage, loadLanguage } from './i18n';
import './styles/global.css';

// Safari on iPhone and iPad applies :active, and with it the pressed state layer (TF-88), only once
// the page listens for touches. An empty passive listener costs nothing and blocks no scrolling.
document.addEventListener('touchstart', () => {}, { passive: true });

// The pages load in chunks (app/App.tsx). After a deployment the chunks of the build this page runs
// are gone, so the next area opened fails to load: reloading fetches the new build. At most once a
// minute, so a chunk that is really missing ends on the error page rather than in a reload loop.
window.addEventListener('vite:preloadError', (event) => {
  const key = 'doculat.chunkReload';
  try {
    if (Date.now() - Number(sessionStorage.getItem(key) ?? 0) < 60_000) return;
    sessionStorage.setItem(key, String(Date.now()));
  } catch {
    return;
  }
  event.preventDefault();
  location.reload();
});

// Where a person came from, kept before anything else reads the address (TF-126).
captureAttribution();

// The chosen language's words before the first drawing, so nobody sees English flash past; only that
// language's dictionary is downloaded, English is in this bundle (TF-183).
void loadLanguage(initialLanguage())
  .catch(() => undefined)
  .finally(() =>
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <App />
      </StrictMode>,
    ),
  );
